import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from "@reduxjs/toolkit/query/react";
import { BaseQueryWithReAuth } from "../utils";
import { MDMSFiltersAPIEndpoints } from "./endpoints";
import { logout } from "../auth";

export const userAccessPanelQuery = BaseQueryWithReAuth({
  baseUrl: `${import.meta.env.VITE_MDMS_ASSETS_URL}`,
  credentials: "same-origin",
  setHeaders: (headers) => {
    headers.set(
      "Authorization",
      `Bearer ${localStorage.getItem("accessToken") || ""}`
    );
    return headers;
  }
});

export const userAccessPanelBaseQueryWithInterceptor: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  // eslint-disable-next-line
  {},
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  const result = await userAccessPanelQuery(args, api, extraOptions);
  if (result.error?.status === 403) {
    api.dispatch(logout());
    await userAccessPanelQuery("/auth/users/sign-out", api, extraOptions);
    localStorage.clear();
  }
  return result;
};

const MDMSFiltersAPI = createApi({
  reducerPath: "MDMSFiltersAPI",
  baseQuery: userAccessPanelBaseQueryWithInterceptor,
  endpoints: (builder) => ({
    ...MDMSFiltersAPIEndpoints(builder)
  })
});

export const {
  useGetCirclesQuery,
  useGetDivisionsQuery,
  useGetSubDivisionsQuery,
  useGetZonesQuery
} = MDMSFiltersAPI;

export default MDMSFiltersAPI;
